import React from 'react'
import PropTypes from 'prop-types'

import { Overlay } from 'components/Overlay';

import './style.scss'

const Info = ({ children }) => {
    return (
        <div className='info'>
            <Overlay
                overlay={
                    <div className='info_overlay'>
                        {children}
                    </div>
                }
            >
                <i className="fa fa-info-circle" aria-hidden="true"></i>
            </Overlay>
        </div >
    )
}
Info.propTypes = {
    children: PropTypes.node
}

export default Info
